import { ToastController, ToastOptions } from '@ionic/angular';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  toast: HTMLIonToastElement[] = [];
  constructor(private toastController: ToastController, private translate: TranslateService) {
    // TODO: find better way to handle this
    // fix toast not presented when offline, due to lazy loading the toast controller.
    // solution from https://github.com/ionic-team/ionic/issues/17450 using <ion-toast> is no longer working
    this.toastController.create({ animated: false }).then(t => {
      t.present();
      t.dismiss();
    });
  }

  public async showOfflineToast(heading: string, message?: string, options?: ToastOptions): Promise<HTMLIonToastElement> {
    await this.closeOfflineToast();
    if (!message) {
      message = this.translate.instant('ToastMessages.offlineToastError');
    }
    options = Object.assign(options || {}, {
      message: `<b>${heading}</b> <br>${message}`,
      cssClass: 'offline-toast ' + options?.position,
      buttons: [
        {
          side: 'start',
          icon: 'alert-circle',
          cssClass: 'offline-toast-icon',
          handler: /* istanbul ignore next  */ () => false,
        },
      ],
    });
    const toast = await this.toastController.create(options);
    await this.present(toast);
    return toast;
  }

  public async closeOfflineToast() {
    /* istanbul ignore else */
    if (this.toast) {
      this.toast.forEach(
        /* istanbul ignore next */ async toast => {
          await toast.dismiss();
        }
      );
    }
    this.toast = [];
  }

  /* istanbul ignore next */
  private async present(toast: HTMLIonToastElement) {
    this.toast.unshift(toast);
    await toast.present();
  }
}
